{
    "all_claims": "All claims",
    "all_claims_uploaded_to_your_workspace": "All claims uploaded to your workspace",
    "all_statuses": "All statuses",
    "all_users": "All users",
    "approve_change": "Approve change",
    "ask_about_fields_evidence_or_rules": "Ask about fields, evidence, or rules…",
    "ask_about_this_claim": "Ask about this claim",
    "ask_assistant": "Ask assistant",
    "assistant_activity": "Assistant activity",
    "assistant_bpjs_intro": "I can explain OCR text, saved fields, existing findings, and BPJS rules using Google Search.",
    "assistant_description": "Review claim evidence and relevant {{program}} rules. Verify answers before submitting your claim.",
    "assistant_philhealth_intro": "I can explain saved fields, document evidence, review status, and relevant PhilHealth circulars.",
    "automatically_upload_each_pdf_and_create_a_separate_claim_for_processing": "Automatically upload each PDF and create a separate claim for processing.",
    "available_after_claim_processing_completes": "Available after claim processing completes",
    "back_to_files": "Back to files",
    "blocking_errors": "Blocking errors",
    "blocking_field_issues_one": "Fix {{count}} blocking field issue before saving the affected values.",
    "blocking_field_issues_other": "Fix {{count}} blocking field issues before saving the affected values.",
    "blocks_save": "Blocks save",
    "bpjs_combine_confirm_hint": "Confirm the PDF to create one durable BPJS claim.",
    "bpjs_extraction_hint": "We extract fields and preserve source evidence.",
    "bpjs_operations": "BPJS operations",
    "bpjs_review_after_confirm_hint": "Confirm reviewed fields before running the comprehensive BPJS review.",
    "bpjs_review_fields_hint": "Review fields before running the comprehensive BPJS review.",
    "bpjs_separate_pdf_hint": "Each PDF becomes a separate durable BPJS claim.",
    "bpjs_upload_folder_hint": "We'll read your BPJS claim packets and add them to the selected folder. Processing continues in the background if you navigate away.",
    "bpjs_upload_hint": "We'll read your BPJS claim packets and prepare fields for review. Processing continues in the background if you navigate away.",
    "cancel": "Cancel",
    "cancel_claim": "Cancel claim?",
    "cancel_claim_action": "Cancel claim",
    "change_the_flagged_values_or_diagnosis_links_below_then_save_to_recheck": "Change the flagged values or diagnosis links below, then save to recheck. Confirming the unchanged value cannot resolve this issue. You can still save progress.",
    "chat_from": "Chat from {{date}}",
    "check_the_claims_list_before_uploading_again": "Check the claims list before uploading again",
    "checking_file": "Checking file {{file}} of {{total}}...",
    "checking_selected_files": "Checking selected files...",
    "claim": "Claim",
    "claim_actions_label": "Actions for {{name}}",
    "claim_assistant": "Claim assistant",
    "claim_created": "Claim created",
    "claim_document": "Claim document",
    "claim_field": "Claim field",
    "claim_field_sections": "Claim field sections",
    "claim_fields": "Claim Fields",
    "claim_name": "Claim name",
    "claim_review": "Claim review",
    "claim_sections": "Claim sections",
    "claim_status_labels": {
        "failed": "Failed",
        "processed": "Processing complete",
        "processing": "Processing",
        "queued": "Queued",
        "review_fields": "Review needed",
        "review_risks": "Risks to review",
        "reviewing_risks": "Reviewing risks"
    },
    "claim_uploaded_processing_started": "Claim uploaded - processing started.",
    "claims_page_summary_one": "Showing {{count}} claim · Cached total: {{total}}",
    "claims_page_summary_other": "Showing {{count}} claims · Cached total: {{total}}",
    "claims_with_active_denial_risks": "Claims with active denial risks",
    "clear_all": "Clear all",
    "clear_claim_search": "Clear claim search",
    "clear_document_search": "Clear document search",
    "combine_order_hint": "Files are combined in the exact order shown.",
    "combine_preview_hint": "Preview the generated PDF before anything is uploaded.",
    "combine_upload_count_one": "Combine and upload {{count}} page",
    "combine_upload_count_other": "Combine and upload {{count}} pages",
    "combined_claim_pages_one": "{{count}} page in one claim",
    "combined_claim_pages_other": "{{count}} pages in one claim",
    "combined_claim_pdf": "combined claim PDF",
    "combined_claim_uploaded_processing_started": "Combined claim uploaded - processing started.",
    "combined_page_limit": "A combined claim can contain at most {{limit}} pages.",
    "combined_pdf_file_name": "Combined PDF file name",
    "combined_type_error": "{{name}}: use PDF, JPEG, PNG, BMP, WebP, or TIFF files for a combined claim.",
    "combining_page": "Combining page {{page}} of {{total}} · {{name}}",
    "complete_this_field_when_possible": "Complete this field when possible.",
    "confirm_current_value": "Confirm current value",
    "confirm_or_correct_the_authoritative_value": "Confirm or correct the authoritative value.",
    "conversation_unavailable": "Conversation unavailable",
    "correction_required": "Correction required",
    "corrections_pending": "Corrections pending",
    "could_not_complete_the_upload": "Could not complete the upload",
    "could_not_get_an_upload_url": "Could not get an upload URL.",
    "could_not_load_dashboard_counts_use_refresh_counts_to_try_again": "Could not load dashboard counts. Use Refresh counts to try again.",
    "could_not_load_recent_claims": "Could not load recent claims.",
    "could_not_preview_this_file": "Could not preview this file",
    "could_not_refresh_counts_try_again": "Could not refresh counts. Try again.",
    "counts_unavailable": "Counts unavailable",
    "create_folder": "Create folder",
    "created": "Created",
    "created_by": "Created by",
    "created_claims_count": "{{number}} claims created",
    "creating_claim": "Creating claim",
    "creating_claim_progress": "Creating claim...",
    "currently_reading_or_reviewing": "Currently reading or reviewing",
    "dashboard_counts": "Dashboard counts",
    "delete": "Delete",
    "destination_folder": "Destination folder",
    "discard_changes": "Discard changes",
    "dismiss": "Dismiss",
    "dismiss_proposal_failed": "Couldn't dismiss this proposal. Please try again.",
    "document_page": "Document page {{page}}",
    "download_original": "Download original",
    "download_pdf": "Download PDF",
    "download_the_original_file_to_review_it": "Download the original file to review it.",
    "download_the_pdf_to_review_it_before_uploading": "Download the PDF to review it before uploading.",
    "drop_auto": "Drop {{program}} claim PDFs here to upload automatically",
    "drop_files_to_combine_into_one_claim": "Drop files to combine into one claim",
    "drop_limit": "Drag and drop PDFs here, or click to select up to {{limit}} separate claims.",
    "drop_preview": "Drop {{program}} claim PDFs here to review",
    "e_g_q1_intake": "e.g. Q1 Intake",
    "each_claim_uploads_automatically_and_joins_the_processing_queue_when_created": "Each claim uploads automatically and joins the processing queue when created.",
    "evidence_page": "Page {{page}}",
    "explain_the_existing_findings": "Explain the existing findings",
    "extracting_claim_data": "Extracting claim data",
    "failed_to_create_the_combined_pdf_preview": "Failed to create the combined PDF preview.",
    "failed_to_upload_claim": "Failed to upload claim",
    "failed_to_upload_the_combined_claim": "Failed to upload the combined claim.",
    "failed_upload_count_one": "{{count}} claim PDF could not be uploaded.",
    "failed_upload_count_other": "{{count}} claim PDFs could not be uploaded.",
    "field_changes_are_only_applied_after_you_approve_a_proposal": "Field changes are only applied after you approve a proposal.",
    "field_review": {
        "blocking_errors_one": "{{count}} blocking error",
        "blocking_errors_other": "{{count}} blocking errors",
        "blocking_validation_issues_one": "{{count}} blocking field validation issue",
        "blocking_validation_issues_other": "{{count}} blocking field validation issues",
        "collapse_section": "Collapse {{section}} section. {{counts}}.",
        "complete": "Review complete",
        "expand_section": "Expand {{section}} section. {{counts}}.",
        "fields_need_review_one": "{{count}} field needs review",
        "fields_need_review_other": "{{count}} fields need review",
        "fields_need_review_tooltip_one": "{{count}} field need review",
        "fields_need_review_tooltip_other": "{{count}} fields need review",
        "fields_needing_review_one": "{{count}} field needing review",
        "fields_needing_review_other": "{{count}} fields needing review",
        "jump_to_section": "Jump to claim field section. Current section: {{section}}. {{counts}}.",
        "matches_one": "{{count}} match",
        "matches_other": "{{count}} matches",
        "missing_recommended_fields_one": "{{count}} recommended field missing",
        "missing_recommended_fields_other": "{{count}} recommended fields missing",
        "no_remaining_indicators": "No remaining review indicators",
        "open_items": "Open review items. {{total}} items.",
        "optional_recommendations_one": "{{count}} optional recommendation",
        "optional_recommendations_other": "{{count}} optional recommendations",
        "pending_suggestions_one": "{{count}} pending suggestion",
        "pending_suggestions_other": "{{count}} pending suggestions",
        "required_items_one": "{{count}} item requires review",
        "required_items_other": "{{count}} items require review",
        "section_indicators_one": "{{count}} review indicator in this section",
        "section_indicators_other": "{{count}} review indicators in this section",
        "system_suggested_fields_one": "{{count}} system-suggested field to review",
        "system_suggested_fields_other": "{{count}} system-suggested fields to review",
        "system_suggestions_one": "{{count}} system suggestion",
        "system_suggestions_other": "{{count}} system suggestions",
        "unsaved_changes_one": "{{count}} unsaved change",
        "unsaved_changes_other": "{{count}} unsaved changes"
    },
    "filings": "Filings",
    "filter_by_user": "Filter by user",
    "filter_claims_by_status": "Filter claims by status",
    "filter_status": {
        "processing": "Processing",
        "processing_complete": "Processing complete",
        "queued": "Queued",
        "review_needed": "Review needed",
        "risks_to_review": "Risks to review"
    },
    "final_page": "Final page {{page}}",
    "final_page_lowercase": "final page {{page}}",
    "final_pages": "Final pages {{start}}–{{end}}",
    "final_pages_lowercase": "final pages {{start}}–{{end}}",
    "finalizing_pdf": "Finalizing the combined PDF...",
    "finalizing_preview": "Finalizing preview...",
    "find_a_claim_field_across_all_sections": "Find a claim field across all sections",
    "find_a_field": "Find a field…",
    "fix_the_blocking_issues_included_in_this_save": "Fix the blocking issues included in this save.",
    "fix_these_values_before_saving_the_affected_fields": "Fix these values before saving the affected fields.",
    "folder_actions_label": "Folder actions for {{name}}",
    "folder_claim_count_one": "{{count}} claim",
    "folder_claim_count_other": "{{count}} claims",
    "folder_name": "Folder name",
    "folders": "Folders",
    "folders_appear_once_a_claim_is_added_you_can_upload_or_move": "Folders appear once a claim is added. You can upload or move a claim here to keep it.",
    "fullscreen": "Fullscreen",
    "generated_pdf": "the generated PDF",
    "google_suggestions_label": "Google Search suggestions {{number}}",
    "helpful_information_that_does_not_block_completion": "Helpful information that does not block completion.",
    "high_risk": "High risk",
    "hospital_dashboard": "Hospital dashboard",
    "hospital_dashboard_unavailable": "Hospital dashboard unavailable",
    "id": "ID: ",
    "in_progress": "In progress",
    "invalid_value": "Invalid value",
    "job_complete": "Complete",
    "jump_to_section": "Jump to section",
    "keep_editing_save_actions_resume_when_risk_review_finishes": "Keep editing; save actions resume when risk review finishes.",
    "latest_uploads_and_their_current_review_status": "Latest uploads and their current review status.",
    "limited_search_results": "Showing the first {{number}} matches. Refine your search to see more.",
    "live_field_validation_is_unavailable_the_server_will_still_validate_fields_when": "Live field validation is unavailable. The server will still validate fields when you save.",
    "loading_claims": "Loading claims",
    "loading_conversation": "Loading conversation",
    "loading_dashboard": "Loading dashboard",
    "loading_field_validation_before_saves_are_enabled": "Loading field validation before saves are enabled.",
    "loading_preview": "Loading preview...",
    "loading_saved_chats": "Loading saved chats",
    "loading_scanner": "Loading scanner…",
    "low_risk": "Low risk",
    "match_position": "{{current}} of {{total}}",
    "message_the_claim_assistant": "Message the claim assistant",
    "moderate_risk": "Moderate risk",
    "monitor_bpjs_claim_intake_denial_risks_and_reimbursement_opportunities_across_your_organization": "Monitor BPJS claim intake, denial risks, and reimbursement opportunities across your organization.",
    "move_2": "Move",
    "move_claim": "Move claim",
    "move_claim_description": "Move {{name}} to another folder.",
    "move_claim_label": "Move {{name}}",
    "my_claims": "My claims",
    "navigation": {
        "analytics": "Analytics",
        "claim_configuration": "Claim Configuration",
        "claims": "Claims",
        "home": "Home",
        "rules": "Rules",
        "settings": "Settings"
    },
    "needs_attention": "Needs attention",
    "needs_review": "Needs review",
    "new_chat": "New chat",
    "new_claim": "New claim",
    "new_folder": "New folder",
    "next": "Next",
    "next_matching_page": "Next matching page",
    "next_refresh_at": ": Next refresh at:",
    "next_section_needing_review": "Next section needing review",
    "no_claims_match_the_current_filters": "No claims match the current filters.",
    "no_claims_yet": "No claims yet",
    "no_field_or_section_found": "No field or section found.",
    "no_fields_in_this_group_yet": "No fields in this group yet.",
    "no_matches": "No matches",
    "no_saved_chats": "No saved chats",
    "nothing_is_uploaded_yet_preview_the_pdfs_then_upload_when_ready": "Nothing is uploaded yet. Preview the PDFs, then upload when ready.",
    "one_combined_claim": "One combined claim",
    "open": "Open",
    "open_claim": "Open claim",
    "optional": "Optional",
    "pdf_preview_is_unavailable_in_this_browser": "PDF preview is unavailable in this browser.",
    "pending_risks_one": "{{count}} risk to review",
    "pending_risks_other": "{{count}} risks to review",
    "please_upload_pdf_claim_documents_only": "Please upload PDF claim documents only.",
    "prepare_page": "Preparing page {{page}} of {{total}} · {{name}}",
    "preparing_preview": "Preparing preview...",
    "preparing_the_claim": "Preparing the claim…",
    "preparing_the_response": "Preparing the response…",
    "preview": "Preview ",
    "preview_before_upload": "Preview before upload",
    "preview_claim_position": "Claim {{current}} of {{total}} · ",
    "preview_combined_claim": "Preview combined claim",
    "preview_combined_pdf": "Preview combined PDF",
    "preview_file": "Preview {{name}}",
    "preview_file_position": "File {{position}} of {{total}} · {{pages}} · ",
    "preview_of_file": "Preview of {{name}}",
    "preview_pdfs": "Preview PDFs",
    "preview_separate_claims": "Preview separate claims",
    "previous": "Previous",
    "previous_matching_page": "Previous matching page",
    "processing_errors_requiring_follow_up": "Processing errors requiring follow-up",
    "proposal_failed": "The field wasn't changed. Please try again.",
    "proposed_field": "Proposed field",
    "read_only_chat_fields_and_findings_cannot_be_changed_here": "Read-only chat. Fields and findings cannot be changed here.",
    "reading_document": "Reading document",
    "recent_claims": "Recent claims",
    "recent_claims_unavailable": "Recent claims unavailable",
    "recommended": "Recommended",
    "refresh_counts": "Refresh counts",
    "refreshing_counts": "Refreshing counts",
    "remaining_uploads_count": "{{number}} remaining",
    "remove": "Remove",
    "remove_claim_description": "This will remove {{name}} and its processing results.",
    "remove_claim_label": "Remove claim {{name}}",
    "remove_file": "Remove {{name}}",
    "rename": "Rename",
    "rename_claim": "Rename claim",
    "rename_claim_label": "Rename {{name}}",
    "rename_folder": "Rename folder",
    "reorder_file": "Reorder {{name}}",
    "required_to_save": "Required to save",
    "rerun_risk_review": "Rerun risk review",
    "resize_claim_assistant": "Resize claim assistant",
    "retrieved": "Retrieved",
    "retry": "Retry",
    "retry_combined_upload": "Retry combined upload",
    "retry_failed_uploads": "Retry failed uploads",
    "retry_loading_chats": "Retry loading chats",
    "retry_risk_review": "Retry risk review",
    "retry_upload": "Retry upload",
    "review": "Review",
    "review_claim_label": "Review {{name}}",
    "review_claim_submissions": "Review claim submissions",
    "review_combined_pages_one": "Review {{count}} page in {{name}} before uploading.",
    "review_combined_pages_other": "Review {{count}} pages in {{name}} before uploading.",
    "review_incomplete": "Review incomplete",
    "review_items": "Review items",
    "review_needed": "Review needed",
    "review_selections_and_filing_specific_values_before_confirmation": "Review selections and filing-specific values before confirmation.",
    "review_this_value_before_finalizing_fields": "Review this value before finalizing fields.",
    "review_values_proposed_by_the_system": "Review values proposed by the system.",
    "risk_review_outdated": "Risk review outdated",
    "risk_review_running": "Risk review running",
    "risks_to_review": "Risks to review",
    "save": "Save",
    "save_change_and_mark_reviewed": "Save change and mark reviewed",
    "save_changes_and_recheck": "Save changes and recheck",
    "save_or_discard_these_local_edits": "Save or discard these local edits.",
    "save_progress": "Save progress",
    "saved_chats_unavailable": "Saved chats unavailable",
    "saving_your_message": "Saving your message…",
    "scan_a_claim": "Scan a claim",
    "scanning_is_unavailable_you_can_still_use_either_file_upload_tab": "Scanning is unavailable. You can still use either file-upload tab.",
    "search_by_field_section_or_common_abbreviation": "Search by field, section, or common abbreviation.",
    "search_claim_fields": "Search claim fields",
    "search_claims": "Search claims",
    "search_claims_by_prefix": "Search claims by prefix",
    "search_document_text": "Search document text",
    "search_document_text_2": "Search document text...",
    "search_field_or_section_names": "Search field or section names…",
    "section_count": "{{number}} sections",
    "section_review_complete": "Section review complete",
    "select_a_saved_chat": "Select a saved chat",
    "select_an_item_to_review_or_correct_it": "Select an item to review or correct it.",
    "select_another_saved_chat_or_start_a_new_chat": "Select another saved chat or start a new one.",
    "select_at_least_one_claim_pdf_to_upload": "Select at least one claim PDF to upload.",
    "select_at_least_one_file_to_combine": "Select at least one file to combine.",
    "select_at_least_one_file_to_preview": "Select at least one file to preview.",
    "select_folder": "Select folder",
    "select_pdfs_or_scanner_images_new_selections_are_appended_in_the_order": "Select PDFs or scanner images. New selections are appended in the order shown below.",
    "selected_claim_pdfs_one": "{{count}} claim PDF selected",
    "selected_claim_pdfs_other": "{{count}} claim PDFs selected",
    "selected_files_summary_one": "{{count}} file · {{size}} selected",
    "selected_files_summary_other": "{{count}} files · {{size}} selected",
    "send_message": "Send message",
    "separate_claims": "Separate claims",
    "separate_upload_hint": "Use this when each PDF represents a different claim. Up to {{limit}} PDFs can be uploaded automatically, or reviewed before upload.",
    "source_evidence": "Source evidence",
    "source_file": "source file",
    "source_page_count_one": "{{count}} page",
    "source_page_count_other": "{{count}} pages",
    "source_pdf": "Source PDF",
    "source_pdf_unavailable": "Source PDF unavailable",
    "sources": "Sources",
    "start_a_new_chat": "Start a new chat",
    "status": "Status",
    "summarize_this_claim": "Summarize this claim",
    "supporting_evidence": "Supporting evidence",
    "system_suggestions": "System suggestions",
    "the_assistant_couldn_t_complete_this_response": "The assistant couldn't complete this response",
    "the_assistant_couldn_t_respond_your_message_was_not_lost_retry_when": "The assistant couldn't respond. Your message was not lost; retry when you're ready.",
    "the_claim_may_have_been_created_even_though_confirmation_was_lost_retrying": "The claim may have been created even though confirmation was lost. Retrying here could create a duplicate claim.",
    "the_selected_file": "The selected file",
    "the_selected_files_exceed_the_combined_upload_limits": "The selected files exceed the combined upload limits.",
    "the_selected_source_files_exceed_the_200_mb_combined_size_limit": "The selected source files exceed the 200 MB combined size limit.",
    "the_source_file_could_not_be_previewed": "The source file could not be previewed.",
    "the_source_pages_are_available_for_comparison": "The source pages are available for comparison.",
    "the_uploaded_document_preview_will_appear_here_once_available": "The uploaded document preview will appear here once available.",
    "this_claim": "this claim",
    "this_updates_the_claim_label_shown_across_your_workspace": "This updates the claim label shown across your workspace.",
    "total_claims": "Total claims",
    "try_loading_your_saved_chats_again": "Try loading your saved chats again.",
    "trying_again": "Trying again…",
    "unconfirmed_count_one": "{{count}} needs verification",
    "unconfirmed_count_other": "{{count}} need verification",
    "unconfirmed_processing": "Could not confirm processing",
    "unconfirmed_upload_count_one": "{{count}} {{program}} claim could not be confirmed. Check the claims list before uploading again.",
    "unconfirmed_upload_count_other": "{{count}} {{program}} claims could not be confirmed. Check the claims list before uploading again.",
    "unreadable_file": "{{name}}: the file could not be read.",
    "unsaved": "Unsaved",
    "unsaved_changes": "Unsaved changes",
    "updates_this_folder_and_all_nested_claims": "Updates this folder and all nested claims.",
    "upload": "Upload",
    "upload_a_bpjs_claim_pdf_to_begin_automated_review": "Upload a BPJS claim PDF to begin automated review.",
    "upload_and_processing_status_updates_independently_for_every_claim": "Upload and processing status updates independently for every claim.",
    "upload_another_batch": "Upload another batch",
    "upload_claim": "Upload claim",
    "upload_claim_count_one": "Upload {{count}} claim",
    "upload_claim_count_other": "Upload {{count}} claims",
    "upload_claims": "Upload claims",
    "upload_claims_automatically": "Upload claims automatically",
    "upload_combined_claim": "Upload combined claim",
    "upload_failed": "Upload failed",
    "upload_failures_count": "{{number}} upload failed",
    "upload_limit": "Please upload no more than {{limit}} claim PDFs at once.",
    "upload_queued": "Upload queued",
    "upload_results": "Upload results",
    "uploaded": "Uploaded",
    "uploading": "Uploading",
    "uploading_and_starting_claims": "Uploading and starting claims",
    "uploading_combined_progress": "Uploading combined PDF... {{percent}}%",
    "uploads_count": "{{number}} uploaded",
    "uploads_finished": "{{finished}} of {{total}} finished",
    "uploads_started": "{{number}} claims uploaded - processing started.",
    "use_the_inline_suggestion_actions_before_saving_an_edited_suggested_field": "Use the inline suggestion actions before saving an edited suggested field.",
    "use_the_inline_suggestion_actions_to_save_your_value_or_reject_the": "Use the inline suggestion actions to save your value or reject the suggestion.",
    "use_this_when_pdfs_and_scanner_images_belong_to_one_claim_review": "Use this when PDFs and scanner images belong to one claim. Review their order, preview the final PDF, then upload it as one claim.",
    "used_for_the_combined_preview_download_and_uploaded_claim_the_name_will": "Used for the combined preview, download, and uploaded claim. The name will end in .pdf.",
    "usually_a_few_minutes_per_claim": "Usually a few minutes per claim",
    "value_no": "No",
    "value_unset": "Not set",
    "value_yes": "Yes",
    "view_all": "View all",
    "view_all_claims": "View all claims",
    "view_claims": "View claims",
    "view_data": "Data",
    "view_document": "Document",
    "view_mode_description": "{{mode}} view",
    "view_page": "View page ",
    "view_split": "Split",
    "waiting_retry": "Waiting for upload retry",
    "waiting_upload": "Waiting for upload",
    "web_research": "Web research",
    "what_happens_next": "What happens next",
    "which_bpjs_rules_apply_to_this_claim": "Which BPJS rules apply to this claim?",
    "whole_files_can_be_reordered_pages_inside_pdfs_and_tiffs_stay_together": "Whole files can be reordered. Pages inside PDFs and TIFFs stay together.",
    "work_performed": "Work performed",
    "your_message_is_saved_and_can_be_retried": "Your message is saved and can be retried."
}
